import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const RenderWpForm = () => {

const navigate = useNavigate();
	

/*
had an error with sessionStorage.getItem("RESTURL") returning null 
when below declaration was before this const RenderWpForm
*/
const resturl=sessionStorage.getItem("RESTURL");
//var boolFetchingSads=false;


//getresturl();



window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});

let submitEventListenerAdded=false;

const location = useLocation();

const [dowait, setDowait] = useState({show: false});

const [visastatusoptions, setVisastatusoptions] = useState([]);
const [visameetingoptions, setVisameetingoptions] = useState([]);

const [tblvsalogs, setTblvsalogs] = useState([]);
const [vsaapp, setVsaapp] = useState({});
const [oldstatus, setOldstatus] = useState({value:""});

const [vsaapplog, setVsaapplog] = useState({
VSA_APP_ID:""
,DECISION_DATE:""
,VISA_STATUS:""
,NOTE:""
,UPDATED:false
});

useEffect(() => {
//console.log('useEffect resturl: '+sessionStorage.getItem("RESTURL"));

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if

document.title =   "APS Applications";	

if (location.state.vsaapp)
	setVsaapp(location.state.vsaapp);

	
 },[]);



useEffect(() => {
	

if (vsaapp.VSA_APP_ID){
	//document.getElementById("td_VISA_STATUS").innerHTML=vsaapp.VISA_STATUS;
	setOldstatus({value:vsaapp.VISA_STATUS});
	setVsaapplog((prev)=>{
		return {...prev, VISA_STATUS:vsaapp.VISA_STATUS}
	});
	gettblvsalog();
	}//end if

 },[vsaapp.VSA_APP_ID]);


useEffect(() => {
	

if (document.getElementsByName("NOTE")[0]){
//if (name=="VISA_STATUS" && value!=oldstatus.value)
	document.getElementsByName("NOTE")[0].focus();
	if (!submitEventListenerAdded){
		//this is added here becase otherwise it does not see the note and date inputs
		submitEventListenerAdded=true;
		//addSubmitEventListener('form1', subEvtLsrCallback);
		}//end if
	
	}//end if
//.VISA_STATUS, vsaapplog.DECISION_DATE
 },[vsaapplog.DECISION_DATE]);



useEffect(() => {
getvisastatusoptions();
 },[JSON.stringify(tblvsalogs)]);





function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func


function getvisastatusoptions(){


   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };		

  fetch(resturl+'rarvsaform/getvisastatusoptions',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetvisastatusoptions(res) )
      .catch(err => console.log(err));

}//end func

function aftergetvisastatusoptions(res){
	
	//addSubmitEventListener('form1', subEvtLsrCallback);
	
	let tempstatus=[], tempmeeting=[];
	let selected="";
	
	if (res.length!=undefined){
	res.map((col, index) => {
		const band=col['BAND'];
		const val=col['OPT'];
		const opt=col['OPT'];
		const key="status_"+index;
		
		selected=(opt==vsaapp.VISA_STATUS)?"selected":"";
		
		if (band=="MEETING")
			tempmeeting.push(<option key={key} value={val} >{opt}</option>);
		else
			tempstatus.push(<option key={key} value={val} selected={selected} >{opt}</option>);
		
		});//end map
		
		setVisastatusoptions(tempstatus);
		setVisameetingoptions(tempmeeting);
		}//end if
		
}//end func


function subEvtLsrCallback(formId){
	
	if (formId=="form1" && vsaapplog.DECISION_DATE!=""){
		updatevsastatus();
		}//end if
		
}//end func

function addSubmitEventListener(formId, callback){
	//console.log('addSubmitEventListener: '+formId);
	if (!document.getElementById(formId)){
		console.log('aborting addSubmitEventListener.  form not found')
		return;
		}//end if

	let form = document.getElementById(formId);
	// Eventlistener can be another event and on another DOM object this is just an example
	
	form.addEventListener('submit', function (event) {
		// Only needed if event is submit, otherwise this line can be skipped 
		event.preventDefault();

		// This is the important part, test if form is valid
		if (form.checkValidity() === false){
			// This is the magic function that displays the validation errors to the user
			form.reportValidity();   
			return; 
		}

	if (callback)
		callback(formId);

		// Code if all fields are valid; continue form submit or make Ajax call.
	});

}//end function

function updatevsastatus(){
//const resturl=sessionStorage.getItem("RESTURL");
const params={
	USERNAME:sessionStorage.getItem("USERNAME")
	,vsaapplog:vsaapplog
	};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

	setDowait({show: true});

  fetch(resturl+'rarvsaform/updatevsastatus',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdatevsastatus(res) )
      .catch(err => console.log(err));

}//end func


function afterupdatevsastatus(res){
	
	setDowait({show: false});
	
	if (res.length==undefined)
		showsnackbar("please try again.  something went wrong");
	else{
		aftergettblvsalog(res);
		//toggleModalsm();
		showsnackbar("the application status has been updated");
		setOldstatus({value:vsaapplog.VISA_STATUS});
		setVsaapplog((prev)=>{
			return {...prev, DECISION_DATE:"", NOTE:"", UPDATED:true}
		});
//		document.getElementById("td_VISA_STATUS").innerHTML=vsaapp.VISA_STATUS;
		}
}//end func


function gettblvsalog(){
//const resturl=sessionStorage.getItem("RESTURL");
//console.log('resturl: '+resturl);
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {VSA_APP_ID:vsaapp.VSA_APP_ID} )
  };		

  fetch(resturl+'rarvsaform/gettblvsalog',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblvsalog(res) )
      .catch(err => console.log(err));

}//end func


function aftergettblvsalog(res){
if (res.length==undefined)
	return;

	
console.log('aftergettblvsalog, res.length: '+res.length);

let htmrows=[];
let refNum=null, vstatus=null;

res.map((col, index) => {
	const appid=col['VSA_APP_ID'];
	const trkey='tr_'+appid;
	
	if (refNum==null){
		refNum=col['REF_NUM'];
		vstatus=col['VISA_STATUS'];
		
		}
		
	
	const htmrow=<tr key={trkey} >
	<td align='left' >{col['SEQ_NO']}</td>
	<td align='left' >{col['DECISION_DATE']}</td>
	<td align='left' >{col['OLD_STATUS']}</td>
	<td align='left' >{col['NEW_STATUS']}</td>
	<td align='left' >{col['USERNAME']}</td>
	<td align='left' >{col['STAMP']}</td>
	<td align='left' >{col['NOTE']}</td>
	</tr>;
	
	htmrows.push(htmrow);
	
	
});

setTblvsalogs(htmrows);
setVsaapp((prev)=>{
	return {...prev, REF_NUM:refNum, VISA_STATUS:vstatus}
})
}//end func


function handleChange(e){

const {name, value}=e.target;

console.log("name, value: "+name+", "+value);

/*
setVsaapp((prev)=>{
	return {...prev, [name]:value}
});
*/
let newvsaapplog=vsaapplog;
	newvsaapplog={...newvsaapplog
		  , VSA_APP_ID:vsaapp.VSA_APP_ID 
		  , [name]:value 
		};
setVsaapplog(newvsaapplog);
				

}//end func

function clickAdd(e){
	e.preventDefault();
	toggleModalsm();
}//end func



function toggleModalsm() {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");

if (document.querySelector(".trigger"))
	document.querySelector(".trigger").addEventListener("click", toggleModalsm);

if (document.querySelector(".close-button"))
	document.querySelector(".close-button").addEventListener("click", toggleModalsm);

window.addEventListener("click", windowOnClick);
}//end func

function adduserdate(e){
	e.preventDefault();
	
	const elem=document.getElementsByName("DECISION_DATE")[0];
		const len=elem.length;
		let defaultDate="";
		console.log('len: '+len);
		if (len>1)
			defaultDate=elem.options[1].text;
console.log('defaultDate: '+defaultDate);

	const userOpt=prompt('Please enter the meeting date: ',defaultDate);
	if (userOpt){
		console.log('elem.selectedIndex: '+elem.selectedIndex);
		var opt = document.createElement('option');
		opt.value = userOpt;
		opt.innerHTML = userOpt;
		elem.appendChild(opt);
		elem.selectedIndex=len;
		setVsaapplog((prev)=>{
			return {...prev, DECISION_DATE:userOpt}
		})
		}//end if
	else
		elem.selectedIndex=0;
	
}//end func

function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");	
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }
}//end func

function buttonClick(){
addSubmitEventListener('form1', subEvtLsrCallback);	
}//end func

function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}//end func

const refNum=vsaapp.REF_NUM==null?'':vsaapp.REF_NUM;
const AD_USER=sessionStorage.getItem("AD_USER");
/*
console.log("AD_USER:" + AD_USER);
console.log("vsaapp.SUBMITTED_TO_CSC:" + vsaapp.SUBMITTED_TO_CSC);
<a href="#" onClick={(e)=>{clickAdd(e);}} ><img src="img/addbutton.png" border="0" title="click to add new record" /></a>
*/
  return (
    <>
	<h4 align='center' style={{marginBottom:"0px"}} >
	TCI Visa Application {refNum}
	</h4>

{AD_USER!="" && vsaapp.SUBMITTED_TO_CSC!="" && 
<form method='POST' id='form1'  >
<table align='center'  style={{width:"50%"}} >
	<tbody>
		<tr>
		<td align="right" >Type of Visa Applied for:</td>
		<td align="left" >{vsaapp.VSA_TYP}</td>
		</tr>
		<tr>
		<td align="right" >Surety's First and Last Name:</td>
		<td align="left" >{vsaapp.STY_GVN_NAM+" "+vsaapp.STY_SUR_NAM}</td>
		</tr>
		<tr>
		<td align="right" >Visitor's First and Last Name:</td>
		<td align="left" >{vsaapp.VSR_GVN_NAM+" "+vsaapp.VSR_SUR_NAM}</td>
		</tr>
		<tr>
		<td align="right" >Status:</td>
		<td align="left"  >{oldstatus.value}</td>
		</tr>
		<tr>
		<td align="right" >Status Update:</td>
		<td align='left' >
			<select name='VISA_STATUS' value={vsaapplog.VISA_STATUS} onChange={(e)=>{handleChange(e);}} >
			{visastatusoptions}
			</select>
			</td>
		</tr>
		{
		vsaapplog.VISA_STATUS!=oldstatus.value && oldstatus.value!="" && vsaapplog.UPDATED==false &&
		<>
		<tr>
		<td align="right" >
			<a href="#" onClick={(e)=>{adduserdate(e);}} title="add decision date" ><img src="img/add.png" border="0" height="15" /></a>
			&nbsp;&nbsp;
			Decision Date:
		</td>
		<td align='left' >
			{
			vsaapplog.VISA_STATUS=="OVERTURN BY MINISTER" && 
			<input name='DECISION_DATE' value={vsaapplog.DECISION_DATE} required onChange={(e)=>{handleChange(e);}} type="date" />
			}
			{
			vsaapplog.VISA_STATUS!="OVERTURN BY MINISTER" && <>
			<select name='DECISION_DATE' value={vsaapplog.DECISION_DATE} required onChange={(e)=>{handleChange(e);}} >
			<option value="" ></option>
			{visameetingoptions}
			</select>
			</>
			}
		</td>
		</tr>
		<tr>
		<td align='right' >note:</td>
		<td align='left' ><textarea name='NOTE' cols='40' rows='6' value={vsaapplog.NOTE} onChange={(e)=>{handleChange(e);}} >{vsaapplog.NOTE}</textarea></td>
		</tr>
		<tr>
		<td align='right' >&nbsp;</td>
		<td align='left' >
			{dowait.show && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
			{
			!dowait.show && 
			<button className='button' onClick={buttonClick}  >save status update</button>
			}	
		</td>
		</tr>
		</>
		}

		<tr>
		<td align="right" ><a href="#" className="nodecor" onClick={(e)=>{e.preventDefault(); navigate("/vsaform", {state:{VSA_APP_ID:vsaapp.VSA_APP_ID, VISA_STATUS:vsaapplog.VISA_STATUS}});}}  ><img src="img/return.png" border="0" />&nbsp;return to application</a></td>
		<td align="left" ></td>
		</tr>
	</tbody>
	</table>
</form>
}	
	<table align='center' className='customers' style={{width:"65%"}} >
	<thead>
	<tr>
		<th>seq. no</th>
		<th>decision<br/>date</th>
		<th>old status</th>
		<th>new status</th>
		<th>updated<br/>by user</th>
		<th>updated<br/>date & time</th>
		<th>note</th>
	</tr>
	</thead>
	<tbody>
		{tblvsalogs}
	</tbody>
	</table>

	<div className="modalsm">
		<div className="modalsm-content">
			<span className="close-button">&times;</span>
			<div align='center' id='modalsmtext' >
			
		

			
			</div>
		</div>
	</div>

<div id="snackbar">&nbsp;</div>


		{/*
		
        <NavLink ref={navWpform} to={"/wpform"} style={{display:"none"}}
          state={{VSA_APP_ID:0}}  >wpform</NavLink>
		*/}



    </>
  );
  


};


export default RenderWpForm;